const glossaryWord = "_rsgt0ihi9";
const counter = "_rsc42jbvh";

export { counter, glossaryWord };
import "./printer.glossary-word.style.linaria.module.css";
//# sourceMappingURL=printer.glossary-word.style.js.map
